import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import LogInModal from 'flarum/forum/components/LogInModal';
import SignUpModal from 'flarum/forum/components/SignUpModal';

const WP_URL = 'https://pablomartin.com';
const WP_LOGIN_URL = 'https://pablomartin.com/#login';

// Capture-phase click handler for login/signup/reply redirections
// This fires BEFORE Mithril's handlers, ensuring reliable redirection
document.addEventListener('click', function(e) {
  // Logout → WP logout
  if (e.target.closest('.item-logOut')) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    window.location.href = 'https://pablomartin.com/?flarum_logout=1';
    return;
  }

  // Header logo/title → WP homepage (NO login modal)
  if (e.target.closest('.Header-logo') || e.target.closest('.Header-title')) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = WP_URL;
    return;
  }

  // Login/Signup/New Discussion buttons → WP login modal
  if (e.target.closest('.item-logIn') || e.target.closest('.item-signUp') ||
      (e.target.closest('.IndexPage-newDiscussion') && !flarum.core.app.session.user)) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    window.location.href = WP_LOGIN_URL;
    return;
  }

  // "Write a Reply" placeholder and "Log In to Reply" button → WP login modal
  if (!flarum.core.app.session.user) {
    if (e.target.closest('.ReplyPlaceholder') ||
        e.target.closest('.item-reply') ||
        e.target.closest('.DiscussionPage-nav .SplitDropdown-button') ||
        e.target.closest('.DiscussionPage-nav .App-primaryControl')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      window.location.href = WP_LOGIN_URL;
      return;
    }
  }
}, true);

app.initializer.add('pablomartin-wp-bridge', function() {
  // Override LogInModal to redirect to WP login (catches ALL cases that show login modal)
  override(LogInModal.prototype, 'oninit', function() {
    window.location.href = WP_LOGIN_URL;
  });

  // Override SignUpModal to redirect to WP login
  override(SignUpModal.prototype, 'oninit', function() {
    window.location.href = WP_LOGIN_URL;
  });

  // Replace header login/signup buttons with single WP login link
  extend(HeaderSecondary.prototype, 'items', function(items) {
    if (!app.session.user) {
      items.remove('logIn');
      items.remove('signUp');
      items.add('wpLogin', m('a', {
        className: 'Button Button--link',
        href: WP_LOGIN_URL
      }, app.translator.trans('core.forum.header.log_in_link')));
    }
  });
});
